import { UseStore } from '@eastcoal/common/types/zustand'
import { useContextStore } from '@eastcoal/common/utils/zustand'

import { PriceCompareListStoreContext } from '../contexts/StoreContext'
import { PriceCompareListStore } from '../store/interface'

export const usePriceCompareListStore: UseStore<
  PriceCompareListStore
> = selector => {
  return useContextStore(PriceCompareListStoreContext, selector)
}
